module.exports = __webpack_public_path__ + "static/Work-Mobile-b8ad51fec6ce6483b5889f760fd9fd2a.jpg";